import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { colors } from '../../shared/styles';

const StyledFilter = styled.div`
    flex: 0 0 300px;
    background: ${colors.grey.default};
    color: ${colors.white};

    .btn {
        display: block;
        background: ${colors.orange.default};
        color: ${colors.white};
        border-radius: 4px;
        text-align: center;
        text-decoration: none;
        padding: 12px 0;
        width: 100%;
        border: 0;
    }

    .form-wrapper {
        display: inline-block;
        position: relative;
        max-width: 300px;
        width: 100%;
        height: 46px;
        white-space: nowrap;
        box-sizing: border-box;
        font-size: 14px;
    }

    form {
        width: 100%;
        height: 100%;
        display: block;

        input {
            border-radius: 4px;
            background-color: ${colors.white};
            border: solid 1px ${colors.grey.light};
            appearance: none;
            display: inline-block;
            transition: box-shadow .4s ease, background .4s ease;
            border-radius: 4px;
            box-shadow: 0 1px 1px 0 rgba(85, 95, 110, 0.2);
            padding: 0;
            padding-right: 36px;
            padding-left: 46px;
            width: 100%;
            height: 100%;
            vertical-align: middle;
            white-space: normal;
            font-size: inherit;
            box-sizing: border-box;
            outline: 0;

            &:valid ~ button[type="reset"] {
                display: block;
            }
        }

        button {
            &[type="submit"] {
                position: absolute;
                top: 0;
                right: inherit;
                left: 0;
                margin: 0;
                border: 0;
                border-radius: 4px 0 0 4px;
                background-color: rgba(255, 255, 255, 0);
                padding: 0;
                width: 46px;
                height: 100%;
                vertical-align: middle;
                text-align: center;
                font-size: inherit;
                user-select: none;

                svg {
                    width: 18px;
                    height: 18px;
                    vertical-align: middle;
                    fill: #bfc7d8;
                }
            }

            &[type="reset"] {
                display: none;
                position: absolute;
                top: 13px;
                right: 13px;
                margin: 0;
                border: 0;
                background: none;
                cursor: pointer;
                padding: 0;
                font-size: inherit;
                user-select: none;
                fill: #bfc7d8;

                svg {
                    display: block;
                    margin: 4px;
                    width: 12px;
                    height: 12px;
                }
            }
        }
    }

    .search-section {
        padding: 20px;
        border-bottom: solid 1px ${colors.grey.light};
    }

    .stats {
        display: block;
        text-align: center;
        font-size: 14px;
        font-stretch: normal;
        color: ${colors.darkBlue.default};
    }

    h2 {
        margin: 0;
        padding: 20px 30px 20px 30px;
        font-weight: lighter;
        border-bottom: solid 1px ${colors.grey.light};
    }

    a {
        color: ${colors.white};
        text-align: center;
        display: block;
        margin: 0 auto;
        text-decoration: none;
    }
`;

const SVGSyles = {
    display: 'none',
};

const Filter = props => {
    const {
        onFilterChange,
        onFilterReset,
        onFilterSubmit,
        total,
        fetchingTime,
        filter,
        suffix,
    } = props;

    let contactsOrStations = 'contacts';
    let filterBy = 'name, email';

    if (suffix === 'Station') {
        contactsOrStations = 'stations';
        filterBy = 'name, code';
    }

    if (suffix === 'To Let Boards') {
        contactsOrStations = 'to let boards';
        filterBy = 'ref';
    }

    return (
        <StyledFilter>
            <div className="search-wrapper">
                <h2>
                    {suffix}s
                </h2>
                <div className="search-section">
                    <Link className="btn" to={`/${contactsOrStations}/add`}>
                        Add New {suffix}
                    </Link>
                </div>
                <div className="search-section">
                    <div className="form-wrapper">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            style={SVGSyles}
                        >
                            <symbol
                                xmlns="http://www.w3.org/2000/svg"
                                id="sbx-icon-search-13"
                                viewBox="0 0 40 40"
                            >
                                <path
                                    d="M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
                                    fillRule="evenodd"
                                />
                            </symbol>
                            <symbol
                                xmlns="http://www.w3.org/2000/svg"
                                id="sbx-icon-clear-3"
                                viewBox="0 0 20 20"
                            >
                                <path
                                    d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
                                    fillRule="evenodd"
                                />
                            </symbol>
                        </svg>
                        <form
                            className="filter"
                            onSubmit={onFilterSubmit}
                            onReset={onFilterReset}
                        >
                            <input
                                autoFocus={true}
                                type="text"
                                value={filter || ''}
                                onChange={onFilterChange}
                                placeholder={`Filter by ${filterBy}...`}
                                required
                            />
                            <button type="submit">
                                <svg role="img" width="1em" height="1em">
                                    <use xlinkHref="#sbx-icon-search-13" />
                                </svg>
                            </button>
                            <button type="reset">
                                <svg role="img" width="1em" height="1em">
                                    <use xlinkHref="#sbx-icon-clear-3" />
                                </svg>
                            </button>
                        </form>
                    </div>
                </div>
                <div className="search-section">
                    <span className="stats">
                        {total} result{total !== 1 ? 's' : ''} found in{' '}
                        {fetchingTime}ms
                    </span>
                </div>
            </div>
        </StyledFilter>
    );
};

export default Filter;



// WEBPACK FOOTER //
// ./src/components/shared/Filter.js